import xType from 'xtypejs'

export function calculateFileSize(size) {
  if (size) {
    if (size >= 1024) {
      if (size >= (1024 * 1024)) {
        return `${((size / 1024) / 1024).toFixed(2)} MB`
      }
      return `${(size / 1024).toFixed(2)} KB`
    } else {
      return `${size.toFixed(2)} Bytes`
    }
  }
}
export function scrollToFirstValidateFailElement(errors) {
  const yOffset = -100;
  const bodyRect = document.body.getBoundingClientRect()
  var elementName = findFirstElementName(errors)
  if (elementName) {
    let elements = document.getElementsByName(elementName)
    if (elements.length) {
      const y = (elements[0].getBoundingClientRect().top - bodyRect.top) + yOffset;
      // elements[0].parentElement.parentElement.parentElement.scrollIntoView()
      window.scrollTo({ top: y });
      return false
    }
    return true
  }
}

const reISO = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\.\d+Z$/;
export function fixJsonDate(key, value) {
  if (typeof value === 'string' && reISO.test(value)) {
      var p = value.match(/\d+/g);
      return new Date(Date.UTC(p[0],p[1]-1,p[2],p[3],p[4],p[5],p[6]));
  }
  return value;
}

const findFirstElementName = (data) => {

  const getFieldName = (errors) => {
    if (xType(errors) !== 'empty_object' && xType(errors).includes('object')) {
      let firstKey = ''
      if (Object.keys(errors).length > 0) {
        firstKey = Object.keys(errors)[0]
      }
      return firstKey ? `.${firstKey}` + getFieldName(errors[firstKey]) : ''
    } else if (xType(errors) !== 'empty_array' && xType(errors).includes('array')) {
      var index = null

      errors.forEach((x, i) => {
        if (index === null) {
          var fName = getFieldName(x)
        }

        if (fName !== '') {
          index = i
        }
      })

      return index !== null ? `[${index}]` + getFieldName(errors[index]) : ''
    } else {
      return ''
    }
  }

  var fieldName = getFieldName(data)

  return fieldName.startsWith('.') ? fieldName.substring(1) : fieldName
}

// export function scrollToFirstValidateFailElement(errors) {
//   if (errors) {
//     Object.keys(errors).every((x,i)=>{
//       let firstKey = Object.keys(errors)[i]
//       let elements = document.getElementsByName(firstKey)
//       if (elements.length) {
//         elements[0].parentElement.parentElement.parentElement.scrollIntoView()
//         return false
//       }
//       return true
//     })
//   }
// }

// export function calculateFileSize(size) {
//   if (size >= 1024) {
//     if (size >= (1024 * 1024)) {
//       return `${((size / 1024) / 1024).toFixed(2)} MB`
//     }
//     return `${(size / 1024).toFixed(2)} KB`
//   } else {
//     return `${size.toFixed(2)} Bytes`
//   }
// }